import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const updateBlackoutPeriod = async (domain: string, blackoutPeriodId: number, blackoutPeriodData: BlackoutDateProps): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `blackout-period/${blackoutPeriodId}`,
        method: 'PUT',
        params: blackoutPeriodData,
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}